import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Dropdown, Input, Menu, Modal, Row, Table, Tooltip } from 'antd';
import { ColumnsType, TableRowSelection } from 'antd/es/table/interface';
import Title from 'antd/es/typography/Title';
import ModalRejectComponent from 'app/shared/component/modal/reject';
import * as _ from 'lodash';
import EvaluationObjectiveKRComponent from './evaluation-objective';
import { cancelProcess, getEntities, getLimitedProcessEvaluate } from './category-evaluation.reducer';
import { columns } from './config';
import PreviousCategoryEvaluationComponent from './previous-category-evaluation';
import { setFilterCategoryEvaluation } from 'app/entities/filters/filters.reducer';

type ICategoryEvaluationProps = {
    isOpen: boolean;
    onClose: () => void;
    planPeriodId: string;
};

const { Search } = Input;

export const CategoryEvaluationComponent = ({ isOpen, onClose, planPeriodId }: ICategoryEvaluationProps) => {
    const dispatch = useAppDispatch();
    const treeData = useAppSelector(state => state.categoryEvaluation.entities);
    const loading = useAppSelector(state => state.categoryEvaluation.loading);
    const account = useAppSelector(state => state.authentication.account);
    const filters = useAppSelector(state => state.filters.categoryEvaluation);

    const [isOpenModalEvaluationItemSelected, setOpenModalEvaluationItemSelected] = useState(false);

    const [processSelected, setProcessSelected] = useState(null);
    const [isOpenModalConfirmCancelProcess, setOpenModalConfirmCancelProcess] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const [isOpenModalPreApproval, setOpenModalPreApproval] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const dropDownKrAction = [
        {
            key: 1,
            label: 'Xem kết quả đánh giá các lần trước',
            onclick: (item) => handleViewPreviousEvaluation(item),
        },
    ];

    const columnsConfig = [{
        title: 'Hành động',
        key: 'action',
        width: 100,
        render(item: any) {
            if (item.ownerId)
                return (
                    <div className="action">
                        <span className="action-view">
                            {item?.isViewDetail && item.documentId &&
                                <Tooltip title="Xem chi tiết">
                                    <FontAwesomeIcon
                                        onClick={() => {
                                            handleOpenModalEvaluationItemSelected(item);
                                        }}
                                        icon="eye"
                                    />
                                </Tooltip>
                            }
                        </span>
                        <span className="action-delete">
                            {(item.documentId && item.isFinished === false) &&
                                <Tooltip title="Dừng">
                                    <FontAwesomeIcon
                                        onClick={() => { handleOpenModelConfirmCancelProcess(item) }}
                                        icon="ban"
                                    />
                                </Tooltip>
                            }
                        </span>
                        {/* <span className="action-edit">
                            <Tooltip title="Xuất file">
                                <FontAwesomeIcon
                                    // onClick={() => {
                                    //   !item.objectiveId ? handleWarningDeleteItem(item.id) : handleWarningDeleteItemExpand(item);
                                    // }}
                                    icon={faFileExport}
                                />
                            </Tooltip>

                        </span> */}
                    </div>
                )
        }
    }]

    useEffect(() => {
        handleGetTreeOrg();
    }, [filters])

    useEffect(() => {
        handleGetProcessEvaluationLimited();
    }, [])

    useEffect(() => {
        if (Object.keys(treeData).length > 0) {
            const allRowKeys = getAllRowKeys(treeData);
            setExpandedRowKeys(allRowKeys);
        }
    }, [treeData])

    const newColumns: ColumnsType<any> = _.uniqBy([...columns, ...columnsConfig], 'key') as unknown as ColumnsType<any>;

    const handleGetTreeOrg = () => {
        dispatch(getEntities({ userId: account?.id, searchText: filters?.searchText, planPeriodId: planPeriodId }))
    }

    const handleGetProcessEvaluationLimited = () => {
        dispatch(getLimitedProcessEvaluate({ userId: account?.id, planPeriodId: planPeriodId })).then((res) => {
            if (res && res.payload) {

                const result = (res.payload as any)?.data
                if (result.length > 0) {
                    result.forEach(element => {
                        columns.push(
                            {
                                title: `Cấp ${element}`,
                                key: `cap_${element}`,
                                render(item) {
                                    if (item?.ownerId && item?.levelStatuses !== null &&
                                        item?.levelStatuses?.[`LevelStatus_${element}`]?.status)
                                        return (
                                            <span>{item?.levelStatuses?.[`LevelStatus_${element}`]?.approveLevelName} {item?.levelStatuses?.[`LevelStatus_${element}`]?.status}</span>
                                        )
                                },
                            },)
                    });
                }
            }
        });
    }

    const getAllRowKeys = (item, index = 0) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.ownerName}_${index}_${idx}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children, idx));
            }

            return keys;
        }, []);
    };

    const handleExport = (values) => {
        console.log(values);
    }

    const handleFreeTextSearchQuery = query => {
        dispatch(setFilterCategoryEvaluation({ ...filters, searchText: query }))
    };

    const handleClose = () => {
        onClose();
    };

    const handleOpenModalEvaluationItemSelected = (itemSelected) => {
        setOpenModalEvaluationItemSelected(true);
        setProcessSelected(itemSelected);
    }

    const handleCloseModalEvaluationItemSelected = (isReload = false) => {
        setOpenModalEvaluationItemSelected(false);
        setProcessSelected(null);
        if (isReload) {
            handleGetTreeOrg();
        }
    }

    const handleOpenModelConfirmCancelProcess = (process) => {
        setProcessSelected(process);
        setOpenModalConfirmCancelProcess(true)
    }

    const handleCancelProcess = (reason: string) => {
        const payload = {
            documentId: processSelected.documentId,
            ownerId: processSelected?.ownerId,
            userId: account?.id,
            reason
        }
        dispatch(cancelProcess(payload)).then(() => {
            handleGetTreeOrg();
        });
        setOpenModalConfirmCancelProcess(false);
    }

    const handleRightClick = (event, record, rowIndex) => {
        event.preventDefault();
        if (record.documentId && record.ownerId) {
            const { clientX, clientY } = event;
            setContextMenu(
                <Menu>
                    {dropDownKrAction
                        .map(item =>
                            <Menu.Item key={item.key} onClick={() => { item.onclick(record) }}>{item.label}</Menu.Item>
                        )}
                </Menu>
            );
            setMenuPosition({ x: clientX, y: clientY });
        }
    };

    const handleViewPreviousEvaluation = (record) => {
        setOpenModalPreApproval(true);
        setProcessSelected(record)
    }

    const handleCloseModalPreviousEvaluation = () => {
        setOpenModalPreApproval(false);
        setProcessSelected(null);
    }

    const transformData = (data, index = 0) => {
        return data.map((item, idx) => {
            return {
                ...item,
                key: `${item?.ownerName}_${index}_${idx}`, // Create a unique key for each level
                children: item.children ? transformData(item.children, idx) : undefined
            };
        });
    };

    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'90vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Danh mục đánh giá</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={18}>
                        <Row className='w-100'>
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6}>
                        <Row className='w-100 justify-content-end'>
                            <Button size="large" onClick={handleExport} className="primary">
                                Xuất File
                            </Button>
                        </Row>
                    </Col>
                </div>
                <Table scroll={{ y: '60vh' }} loading={loading}
                    expandable={{
                        expandedRowKeys,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }}
                    bordered dataSource={transformData(treeData)} onRow={(record, index) => {
                        return {
                            onContextMenu: (event) => handleRightClick(event, record, index),
                        };
                    }} pagination={false} columns={newColumns} />
            </div>
            {contextMenu && (
                <Dropdown
                    overlay={contextMenu}
                    open
                    trigger={['contextMenu']}
                    placement="bottomLeft"
                    onOpenChange={(flag) => !flag && setContextMenu(null)}
                    overlayStyle={{
                        position: 'fixed',
                        top: menuPosition.y,
                        left: menuPosition.x,
                        zIndex: 1000,
                    }}
                >
                    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh' }} />
                </Dropdown>
            )}
            {isOpenModalEvaluationItemSelected && <EvaluationObjectiveKRComponent
                accountTableId={processSelected?.ownerId} accountableName={processSelected?.ownerName} documentId={processSelected?.documentId}
                isFinished={processSelected?.isFinished} isOpen={isOpenModalEvaluationItemSelected} onClose={handleCloseModalEvaluationItemSelected} planPeriodId={planPeriodId} />}

            {isOpenModalPreApproval && <PreviousCategoryEvaluationComponent
                accountTableId={processSelected?.ownerId} accountTableName={processSelected?.ownerName} isOpen={isOpenModalPreApproval} onClose={handleCloseModalPreviousEvaluation} planPeriodId={planPeriodId} />}
            <ModalRejectComponent
                visible={isOpenModalConfirmCancelProcess}
                onCancel={() => {
                    setOpenModalConfirmCancelProcess(false);
                }}
                onReject={handleCancelProcess}
                title={`Bạn có chắc chắn muốn dừng quy trình của ${processSelected?.ownerName}`}
            />
        </Modal>
    );
};

export default CategoryEvaluationComponent;
